import { render, staticRenderFns } from "./BrakeOilDetail.vue?vue&type=template&id=9d84187c&scoped=true"
import script from "./BrakeOilDetail.vue?vue&type=script&lang=js"
export * from "./BrakeOilDetail.vue?vue&type=script&lang=js"
import style0 from "./BrakeOilDetail.vue?vue&type=style&index=0&id=9d84187c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d84187c",
  null
  
)

export default component.exports